import React, { Fragment, useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import Mentors from "./components/Mentors";
import Enroll from "./components/Enroll";
import Equation from "./components/Equation";
import Timeline from "./components/Timeline";
import Certificates from "./components/Certificates";
import Stories from "./components/Stories";
import Mentees from "./components/Mentees";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import Counter from "./components/Counter";
import WhoCanApply from "./components/WhoCanApply";
import WhatWillYou from "./components/WhatWillYou";
import InternshipCarousel from "./components/InternshipCarousel";
import { Future } from "./components/Future";
import { BeforeYouAsk } from "./components/BeforeYouAsk";
import { CheckOut } from "./components/CheckOut";
import { StillTrust } from "./components/StillTrust";
import Testimoniais from "./components/Testimoniais";
import SkillsCovered from "./components/SkillsCovered";
import ProFiciency from "./components/ProFiciency";
import QuestionsFaq from "./components/QuestionsFaq";
import CareerBuilding from "./components/CareerBuilding";
import Thankyou from "./Thankyou/Thankyou";
import RightIcon from "./assets/images/right-icon.png";

import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import { SnackbarContent } from "@mui/material";

// Separate HomePage component with all logic
const HomePage = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);

  useEffect(() => {
    let scrollTimeout = null;

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const scrollThreshold = 0;

      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(() => {
        if (scrollTop > lastScrollTop + scrollThreshold) {
          setIsScrolled(true);
        } else if (scrollTop < lastScrollTop - scrollThreshold) {
          setIsScrolled(false);
        }
        setLastScrollTop(scrollTop);
      }, 100);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollTop]);

  const [open, setOpen] = useState(false);
  const [show, setshow] = useState(true);

  const handleClick = () => {
    setOpen(true);
  };

  useEffect(() => {
    setTimeout(() => {
      if (show === true) {
        handleClick();
        setshow(false);
      } else {
        setshow(false);
      }
    }, 5000); // Fixed: Added proper delay instead of [show]
  }, []); // Fixed: Added dependency array

  const handleClose = (reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const action = (
    <Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        X
      </IconButton>
    </Fragment>
  );

  const dataarray = [
    { name: "Raj", place: "Rajasthan", time: "4 hours" },
    { name: "Manoj", place: "Rajashthan", time: "3 hours" },
    { name: "Rushikesh", place: "Gujarat", time: "5 minutes" },
    { name: "Prayag", place: "Madhya Pradesh", time: "4 hours" },
  ];

  const [loadpoup, setloadpopup] = useState(3);

  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      setloadpopup(i);
      setshow(true);
      if (i === dataarray.length - 1) {
        i = 0;
      } else {
        i++;
      }
    }, 10000);

    // Important: Cleanup interval
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ overflow: "hidden" }}>
      {/* <Navbar /> */}
      <HeroSection />
      <WhatWillYou />
      <WhoCanApply />
      <Mentors />
      <Future />
      <Testimoniais />
      <Enroll />
      <BeforeYouAsk />
      <FAQ />
      {/* <InternshipCarousel /> */}
      <SkillsCovered />
      {/* <CareerBuilding /> */}
      {/* <Counter /> */}
      <CheckOut />
      <StillTrust />
      <ProFiciency />
      <QuestionsFaq />
      <Footer />

      {/* Footer Section with Scroll Effect */}
      {/* <div className={`footer-get-ready-section ${isScrolled ? "scrolled" : ""}`}>
        <div className="get-ready-container">
          <div className="get-ready-main">
            <div className="get-ready-left">
              Special <span>Discount! 50% OFF</span>
            </div>
            <div className="get-ready-right">
              <div className="get-price">
                <span>₹18,000</span>
                <strong>₹9000</strong>
              </div>
              <div className="get-register-btn">
                <a href="https://pages.razorpay.com/EDRIVE-WebsiteMain" target="_blank">
                  Register Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <Snackbar
        open={open}
        autoHideDuration={8000}
        onClose={handleClose}
        message="Test"
        action={action}
      >
        <SnackbarContent
          sx={{ backgroundColor: "#bb4420", color: "white" }}
          message={
            <div className="load-popup-main">
              <div className="right-icon">
                <img src={RightIcon} className="right-icon1" />
              </div>

              <div className="load-popup-text">
                <h2>
                  {dataarray[loadpoup].name} from {dataarray[loadpoup].place}
                </h2>
                <p>registered for the Robotics & AI</p>
                <span>{dataarray[loadpoup].time} ago</span>
              </div>
            </div>
          }
          action={action}
        />
      </Snackbar> */}
    </div>
  );
};

// Main App component - only handles routing
const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/thankyou" element={<Thankyou />} />
      </Routes>
    </Router>
  );
};

export default App;